import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

export interface DocumentItem {
  id: string;
  batchId: string;
  sharePointItemId: string;
  fileName: string;
  filePath: string;
  fileExtension: string;
  fileSizeInBytes: number;
  blobUri: string | null;
  status: string;
  errorMessage: string | null;
  retryCount: number;
  createdAt: string;
  processedAt: string | null;
}

export interface DocumentListData {
  total: number;
  page: number;
  pageSize: number;
  items: DocumentItem[];
}

export interface DocumentListResponse {
  statusCode: number;
  success: boolean;
  message: string;
  data: DocumentListData;
}

@Injectable({
  providedIn: 'root'
})
export class Document {
  private baseUrl = `${environment.apiUrl}/documents`;

  constructor(private http: HttpClient) {}

  getDocuments(page: number = 1, pageSize: number = 50, status?: string): Observable<DocumentListResponse> {
    let params = `?page=${page}&pageSize=${pageSize}`;
    if (status) params += `&status=${status}`;
    return this.http.get<DocumentListResponse>(`${this.baseUrl}${params}`);
  }
}